import { useEffect, useState } from "react";
import api from "../api/api";

function Profile() {

  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    address: ""
  });

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: ""
  });

  const [loading, setLoading] = useState(true);

  // 🔥 Load profile
  useEffect(() => {
    api.get("/profile")
      .then(res => setData(res.data))
      .catch(() => alert("Failed to load profile"))
      .finally(() => setLoading(false));
  }, []);

  // 🔥 Update profile
  const updateProfile = async () => {
    try {
      await api.put("/profile/update", data);
      alert("Profile updated successfully ✅");
    } catch {
      alert("Update failed ❌");
    }
  };

  // 🔥 Change password
  const changePassword = async () => {
    if (!password.oldPassword || !password.newPassword) {
      alert("Fill both password fields");
      return;
    }

    try {
      await api.put("/profile/change-password", password);
      alert("Password changed successfully 🔐");

      setPassword({ oldPassword: "", newPassword: "" });

    } catch {
      alert("Password change failed ❌");
    }
  };

  if (loading) return <p>Loading profile...</p>;

  return (
    <div>

      {/* ── PROFILE CARD ───────────────────── */}
      <div className="card mb-24">
        <div className="card-header">
          <div className="card-title">👤 My Profile</div>
        </div>

        <div className="card-body">

          <div className="form-grid">

            <div className="form-group">
              <label className="form-label">Name</label>
              <input className="form-input"
                value={data.name}
                onChange={e => setData({ ...data, name: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input"
                value={data.email}
                onChange={e => setData({ ...data, email: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Phone</label>
              <input className="form-input"
                value={data.phone}
                disabled
              />
            </div>

            <div className="form-group">
              <label className="form-label">Address</label>
              <input className="form-input"
                value={data.address}
                onChange={e => setData({ ...data, address: e.target.value })}
              />
            </div>

          </div>

          <button className="btn btn-gold mt-16" onClick={updateProfile}>
            Update Profile
          </button>

        </div>
      </div>


      {/* ── PASSWORD CARD ───────────────────── */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">🔐 Change Password</div>
        </div>

        <div className="card-body">

          <div className="form-grid">

            <div className="form-group">
              <label className="form-label">Old Password</label>
              <input type="password" className="form-input"
                value={password.oldPassword}
                onChange={e =>
                  setPassword({ ...password, oldPassword: e.target.value })
                }
              />
            </div>

            <div className="form-group">
              <label className="form-label">New Password</label>
              <input type="password" className="form-input"
                value={password.newPassword}
                onChange={e =>
                  setPassword({ ...password, newPassword: e.target.value })
                }
              />
            </div>

          </div>

          <button className="btn btn-primary mt-16" onClick={changePassword}>
            Change Password
          </button>

        </div>
      </div>

    </div>
  );
}

export default Profile;